import React, { useEffect } from 'react'
import "../css/home.css"
import 'aos/dist/aos.css';

import { Button, Card, Col, Container, Row } from 'react-bootstrap'
import { FaHamburger, FaUsers, FaStar } from "react-icons/fa"
import { FiThumbsUp } from 'react-icons/fi'
import { assets, event } from '../assets/assets'
import { useNavigate } from 'react-router-dom'
import Aos from 'aos';

export const Home = () => {

    let navigate = useNavigate()

    useEffect(() => {
        Aos.init({ duration: 1000 })
    }
    );

    return (
        <>
            {/* 🏠 Hero Section */}
            <Container fluid className="home-head-container">
                <Row>
                    <Col md={8} xs={12} data-aos="fade-up">
                        <p className='home-head-text'>Turning Every Celebration into a Feast</p>
                        <p className='home-para'>
                            Crafting authentic Indian flavors, served with love and perfection
                        </p>
                    </Col>
                </Row>
            </Container>

            {/* 🍽️ About / Food Section */}
            <Container fluid>
                <Row>
                    <Col md={7} xs={12} style={{ paddingLeft: "2rem" }}>
                        <h1 style={{
                            fontSize: "2.5rem",
                            fontWeight: "700",
                            marginTop: "3rem",
                            color: "#850814"
                        }}>We Believe in Delicious & Elegant Food</h1>

                        <p style={{ marginTop: "2rem" }}>
                            Crafting unforgettable flavors with every bite — where passion meets perfection. Our culinary experts combine authentic recipes, the freshest ingredients, and a touch of creativity to deliver dishes that don’t just satisfy hunger but create memories that linger long after the meal is over.
                        </p>

                        <Row className="align-items-center justify-content-center g-3">
                            <Col md={6} xs={12} data-aos="fade-right" className="d-flex justify-content-center">
                                <img
                                    src={assets.content1}
                                    alt="Dining Scene"
                                    className="content-img"
                                />
                            </Col>

                            <Col md={6} xs={12} data-aos="fade-right" data-aos-delay="100" className="d-flex justify-content-center">
                                <img
                                    src={assets.content2}
                                    alt="Chef and Dishes"
                                    className="content-img"
                                />
                            </Col>
                        </Row>

                    </Col>

                    <Col
                        md={5}
                        xs={12}
                        className="d-flex justify-content-center align-items-center"
                    >
                        <img src={assets.chief} alt="chief" className="home-chief-img" />
                    </Col>

                </Row>
            </Container>

            {/* 🎉 Services Section */}
            <Container fluid style={{ background: "#f3f8fa", padding: "2rem 2rem" }}>
                <Row>
                    <Col className="text-center">
                        <p className='home-service-head'>Plan Your Event With Our Services</p>
                        <p className='home-service-subhead'>
                            Turning moments into memories with personalized event planning — from intimate gatherings to grand celebrations. Our dedicated team ensures every detail reflects your vision, blending creativity, precision, and warmth to create an experience that feels effortless, beautiful, and truly yours.
                        </p>
                    </Col>
                </Row>

                <Row>
                    {event.map((e, i) => (
                        <Col key={i} md={3} xs={12}>
                            <Card 
                            data-aos="fade-up"
                            data-aos-delay="100"
                            style={{
                                // height:"80%",
                                border: "none",
                                marginTop: "2rem",
                                marginBottom: "2rem",
                                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                                overflow: "hidden",
                            }}>
                                <Card.Img variant="top" src={e.img} className="event-img" />
                                <Card.Body className="text-center">
                                    <p style={{ fontWeight: "600" }}>{e.name}</p>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>


            <Container fluid style={{
                padding: "2rem",
            }}>
                <Row>
                    <Col>
                        <h1 style={{
                            textAlign: "center",
                            padding: "1rem",
                            fontWeight: "700",
                            color: "#850814",
                            fontSize: "2.2rem",
                            letterSpacing: "2px"
                        }}>Packages</h1>
                    </Col>
                </Row>

                <Row>

                    <Col md={4} data-aos="fade-up" data-aos-delay="100" style={{
                        marginBottom: "10px"
                    }}>
                        <Card style={{
                            padding: "1rem",
                            // border: "1px solid grey",
                            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)"

                        }}>
                            <Card.Img src={assets.std_pkg} style={{
                                height: "250px",
                                objectFit: "contain",
                                borderBottom: "1px solid #850814"

                            }}></Card.Img>
                            <Card.Body>
                                <Card.Title style={{ color: "#850814" }}>Standard Package</Card.Title>
                                <Card.Text>
                                    <p style={{ fontWeight: "600" }}>Intimate wedding for 500 guests</p>

                                    <li>11 food items served for 500 guests</li>
                                    <li>Elegant main stage decoration & seating for 200 guests</li>
                                    <li>Dressing room & 10 round tables with decor</li>
                                    <li>Service staff & 2 female greeter at the main gate</li>
                                    <li>Instrumental music & electricity backup</li>
                                    <li>Ample Parking with Security</li>
                                </Card.Text>

                                <p style={{ fontWeight: "600" }}>₹1,00,000 Starting Price</p>
                                <Button onClick={() => navigate("/silverpkg")} className='enquire-now-btn'>Enquire Now</Button>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={4} data-aos="fade-up" data-aos-delay="100" style={{
                        marginBottom: "10px"
                    }}>
                        <Card style={{
                            padding: "1rem",
                            // border: "1px solid grey",
                            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)"

                        }}>
                            <Card.Img src={assets.delux_pkg} style={{
                                height: "250px",
                                objectFit: "contain",
                                borderBottom: "1px solid #850814"
                            }}></Card.Img>
                            <Card.Body>
                                <Card.Title style={{ color: "#850814" }}>Delux Package</Card.Title>
                                <Card.Text>
                                    <p style={{ fontWeight: "600" }}>Intimate wedding for 500 guests</p>

                                    <li>14 food items served for 1000 guests</li>
                                    <li>Elegant main stage decoration & seating for 200 guests</li>
                                    <li>Dressing room & 10 round tables with decor</li>
                                    <li>Service staff & 2 female greeters at the main gate</li>
                                    <li>Instrumental music & electricity backup</li>
                                    <li>Ample Parking with Security</li>

                                </Card.Text>

                                <p style={{ fontWeight: "600" }}>₹1,25,000 Starting Price</p>
                                <Button onClick={() => navigate("/goldenpkg")} className='enquire-now-btn'>Enquire Now</Button>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={4} data-aos="fade-up" data-aos-delay="100" style={{
                        marginBottom: "10px"
                    }}>
                        <Card style={{
                            padding: "1rem",
                            // border: "1px solid grey",
                            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)"
                        }}>
                            <Card.Img src={assets.exec_pkg} style={{
                                height: "250px",
                                objectFit: "contain",
                                borderBottom: "1px solid #850814"
                            }}></Card.Img>
                            <Card.Body>
                                <Card.Title style={{ color: "#850814" }}>Executive Package</Card.Title>
                                <Card.Text>
                                    <p style={{ fontWeight: "600" }}>Intimate wedding for 500 guests</p>

                                    <li>16 food items served for 1000 guests</li>
                                    <li>Elegant main stage decoration & seating for 200 guests</li>
                                    <li>Dressing room & 10 round tables with decor</li>
                                    <li>Service staff & 2 female greeters at the main gate</li>
                                    <li>Instrumental music & electricity backup</li>
                                    <li>Ample Parking with Security</li>

                                </Card.Text>

                                <p style={{ fontWeight: "600" }}>₹1,50,000 Starting Price</p>
                                <Button href="https://wa.me/919923314198" className='enquire-now-btn'>Enquire Now</Button>
                            </Card.Body>
                        </Card>
                    </Col>

                </Row>
            </Container>


            {/* 🍴 Serving Section */}
            <Container fluid
                style={{
                    padding: "2rem"
                }}>

                <Row>
                    <Col data-aos="fade-up" data-aos-delay="100" className="serve-section"
                        style={{ backgroundImage: `url(${assets.serve_bg})` }}>

                        <Row>
                            <Col className="text-center">
                                <h1 className='home-serving-head'>Serving Since 2010</h1>
                                <p className='home-serving-subhead'>
                                    With years of expertise and a passion for hospitality, we’ve proudly served countless events, building trust and excellence since 2010.                                </p>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} style={{ padding: "0 2rem" }}>
                                <Row className="justify-content-center gy-4">
                                    {[
                                        { icon: <FaHamburger />, value: "100", label: "Meals" },
                                        { icon: <FaUsers />, value: "1260", label: "Employees" },
                                        { icon: <FiThumbsUp />, value: "20512", label: "Customers" },
                                        { icon: <FaStar />, value: "9.9/10", label: "Reviews" },
                                    ].map((item, index) => (
                                        <Col
                                            key={index}
                                            xs={12}
                                            sm={6}
                                            md={3}
                                            className="serve-stat-card text-center"
                                        >
                                            <div className="serve-stat-content">
                                                {React.cloneElement(item.icon, {
                                                    style: { fontSize: "2.5rem", color: "#f1c40f" },
                                                })}
                                                <h2>{item.value}</h2>
                                                <p>{item.label}</p>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </Col>
                        </Row>
                    </Col>

                </Row>
            </Container>
        </>
    )
}
